import {
  DialogPositionStrategyInIframe,
  ENVIRONMENTS,
  RETAILERS,
} from '@shared/constants';

export type ProjectType = 'loyaltyChallenge' | 'coupons';
export type EnvironmentType = 'dev' | 'staging' | 'prod' | 'cypress';

export enum ProjectTypes {
  COUPONS = 'coupons', // coupons
  LOYALTY_CHALLENGE = 'loyaltyChallenge', // default
}

export interface Environment {
  lang: string;
  maxReward: number;
  backendUrl: string;
  production: boolean;
  baseHref: string;
  env: ENVIRONMENTS;
  maintenance: boolean;
  reCAPTCHAKey?: string;
  cloudFlareTurnstileKey?: string;
  retailerName: RETAILERS;
  /**
   * Whether the retailer has a secondary ("BIS") campaign that should be loaded
   * and displayed alongside the primary campaign.
   */
  hasCampaignBis: boolean;
  hasBisPage?: boolean;
  projectType: ProjectType;
  maxSelectedChallenges: number;
  dialogPositionStrategyInIframe?: DialogPositionStrategyInIframe;
  showMaxSelectedBisModal?: boolean;
  enableSentry: boolean;
  enableABTest?: boolean;
  ssrAllowedHosts?: string[];
  /**
   * Demo flag: when `true`, the mock data uses real grocery brands
   * (Coca-Cola, Barilla…) instead of random `faker` data. Used for sales-demo
   * videos. Defaults to `false` (random data) when omitted.
   */
  useRealBrands?: boolean;
}
